module.exports = __webpack_public_path__ + "img/178.c6bea66f.jpg";